module.exports = __webpack_public_path__ + "img/arrow-down-left-circle-fill.bf1925b8.svg";